import { render, staticRenderFns } from "./Workshop.vue?vue&type=template&id=14a6d8b4&scoped=true"
import script from "./Workshop.vue?vue&type=script&lang=ts"
export * from "./Workshop.vue?vue&type=script&lang=ts"
import style0 from "./Workshop.vue?vue&type=style&index=0&id=14a6d8b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a6d8b4",
  null
  
)

export default component.exports